export default __webpack_public_path__ + "static/media/Ancient Kukri.e8488452.jpg";